import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import en from './locales/en.json'
import ar from './locales/ar.json'

export const LANG_KEY = 'bv.lang'

void i18n.use(initReactI18next).init({
  resources: { en: { translation: en }, ar: { translation: ar } },
  lng: localStorage.getItem(LANG_KEY) ?? 'en',
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
})

export function setLanguage(lng: 'en' | 'ar') {
  localStorage.setItem(LANG_KEY, lng)
  void i18n.changeLanguage(lng)
}

export function isRtl(lng: string): boolean {
  return lng === 'ar'
}

export default i18n
